import { useEffect, useRef, useState } from "react";
import "./searchstyle.scss";
import { getValue, setValue } from "@utils/lodash";
import { months } from "@_common/month";
import { sanitizeInput } from "@_common/dompurify";
const MonthDropdown = (props) => {
  const { value, placeholder, removeClose } = props;

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [inputChange, setInputChange] = useState(false);
  const inputRef = useRef(null);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    document.addEventListener("click", toggle);
    document.addEventListener("mouseup", toggle);
    return () => {
      document.removeEventListener("click", toggle);
      document.addEventListener("mouseup", toggle);
    };
  }, []);

  useEffect(() => {
    setQuery("");
  }, [props.resetInput]);
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const filter = (options) => {
    return getValue(options, `length`, 0) > 0
      ? options.filter(
          (option) =>
            getValue(option, `label`, "")
              .toLowerCase()
              .indexOf(query.toLowerCase()) > -1
        )
      : [];
  };
  useEffect(() => {
    if (query) {
      setInputChange(true);
    }
  }, [query]);

  let selectedMonth =
    getValue(props, `value`, "") && getValue(filter(months), `length`, 0) > 0
      ? filter(months).filter(
          (item) =>
            parseInt(item.value) === parseInt(getValue(props, `value`, ""))
        )
      : [];

  return (
    <div className={"dropdown-select-calender"}>
      <div className="control">
        <div className="selected-value">
          <input
            ref={inputRef}
            type="text"
            value={
              inputChange
                ? query
                  ? query
                  : getValue(selectedMonth, `[${0}].label`, "")
                : getValue(selectedMonth, `[${0}].label`, "")
                ? getValue(selectedMonth, `[${0}].label`, "")
                : query
            }
            name="searchTerm"
			id="search-text"
            autoComplete="off"
            onChange={(e) => {
              setQuery(sanitizeInput(e.target.value));
            }}
            onClick={toggle}
            placeholder={placeholder ? placeholder : "Month"}
          />
        </div>
        <div className="line"></div>
        <div className={`arrow ${isOpen ? "open" : ""}`}></div>
        {(query || getValue(value, `label`, "")) && !removeClose && (
          <div
            className="close"
            onClick={(e) => {
              setQuery("");
            }}
          >
            &#x2715;
          </div>
        )}
      </div>

      <div className={`options ${isOpen ? "open" : ""}`}>
        {getValue(months, `length`, 0) > 0 &&
        getValue(filter(months), `length`, 0) > 0 ? (
          filter(months).map((option, index) => {
            return (
              <div
                onClick={() => {
                  props.handleSelectDate(option);
                  setInputChange(false);
                }}
                className={`option ${
                  parseInt(getValue(option, `value`, "")) === parseInt(value)
                    ? "selected"
                    : ""
                }`}
                key={`${index}`}
              >
                {getValue(option, `label`, "")}
              </div>
            );
          })
        ) : (
          <div className={`option `} style={{ textAlign: "center" }}>
            No Data Found
          </div>
        )}
      </div>
    </div>
  );
};

export default MonthDropdown;
